import { __decorate, __metadata } from '../../node_modules/tslib/tslib.es6.js';
import { PvdBaseComponent } from '../pvd-base-component/pvd-base-component.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { svg as b, html as x, nothing as A } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../node_modules/lit-html/directives/if-defined.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { Size } from '../pvd-utils/enums/size.js';
import IconNames from './enums/icon-names.js';

const SVG_PROTECTED_ATTR_MAP = new Map([
    ['aria-hidden', 'pvd-a11y-label'],
    ['aria-labelledby', 'pvd-a11y-label'],
    ['focusable', 'pvd-a11y-label'],
    ['role', 'pvd-a11y-label'],
]);
/**
 * Providence Icon component.
 * @see {@link https://providence.fmr.com/4.x/components/icon/icon.html|Icon documentation}
 */
class PvdIcon extends PvdBaseComponent {
    constructor() {
        super(...arguments);
        this._pvdName = 'action__add';
        this._pvdSize = Size.medium;
        // #endregion
    }
    get pvdName() {
        return this._pvdName;
    }
    set pvdName(value) {
        const size = this.pvdSize;
        if (this.validateIconNameForSize(value, size)) {
            const oldVal = this._pvdName;
            this._pvdName = value;
            this.requestUpdate('pvdName', oldVal);
        }
    }
    get pvdSize() {
        return this._pvdSize;
    }
    set pvdSize(value) {
        const name = this.pvdName;
        if (this.validateIconNameForSize(name, value)) {
            const oldVal = this._pvdSize;
            this._pvdSize = value;
            this.requestUpdate('pvdSize', oldVal);
        }
    }
    // #endregion
    // #region private methods
    get iconHref() {
        return `#${this.constructor.namespace}-${this.pvdName}`;
    }
    validateIconNameForSize(name, size) {
        if (size === Size.extraSmall && IconNames.extraSmall.indexOf(name) === -1) {
            console.warn(`You cannot use the '${name}' icon at the 'extra-small' size. Please choose a different icon or a larger size.`);
        }
        return true;
    }
    /**
     * Generates a unique ID for the Icon's title
     */
    generatedA11yLabelledbyId() {
        if (!this._generatedA11yLabelledbyId) {
            this._generatedA11yLabelledbyId = `pvd-icon-title-${PvdBaseComponent.generateRandomNumber()}`;
        }
        return this._generatedA11yLabelledbyId;
    }
    /**
     * Sets attributes on the svg element that are coming from pvdNativeSvgAttributes
     * @param prevAttr optional, if user updates pvdNativeSvgAttributes, this will remove/update existing attributes
     */
    setNativeSvgAttributes(prevAttr) {
        const targetElement = this.querySelector('svg');
        this.setNativeAttributes(this.pvdNativeSvgAttributes, SVG_PROTECTED_ATTR_MAP, targetElement, prevAttr);
    }
    // #endregion
    // #region LitElement lifecycles
    updated(changedProperties) {
        super.updated(changedProperties);
        if (this.pvdNativeSvgAttributes) {
            const prevAttr = changedProperties.get('pvdNativeSvgAttributes');
            // if native attributes are being set, go through the logic of applying attributes to target element
            this.setNativeSvgAttributes(prevAttr);
        }
    }
    renderIconSvgTitle() {
        return b `<title id="${this._generatedA11yLabelledbyId}">${this.pvdA11yLabel}</title>`;
    }
    render() {
        const classMap = {
            default: `${this.constructor.namespace}-icon-root`,
            modifierPrefix: 'pvd-icon',
            modifiers: [
                {
                    condition: this.pvdIconClass !== undefined,
                    className: this.pvdIconClass,
                    modifierPrefix: false,
                },
                {
                    condition: this.pvdSize !== Size.medium,
                    className: `${this.pvdSize}`,
                },
            ],
        };
        return x `<svg aria-hidden="${this.pvdA11yLabel ? 'false' : 'true'}" aria-labelledby="${l(this.pvdA11yLabel ? this.generatedA11yLabelledbyId() : undefined)}" class="${getClassName(classMap)}" focusable="${this.pvdA11yLabel ? 'true' : 'false'}" role="${l(this.pvdA11yLabel ? 'img' : undefined)}">${this.pvdA11yLabel ? this.renderIconSvgTitle() : A}<use href="${this.iconHref}" xlink:href="${this.iconHref}"/></svg>`;
    }
}
//#region Component configuration
PvdIcon.componentName = 'icon';
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-a11y-label' }),
    __metadata("design:type", String)
], PvdIcon.prototype, "pvdA11yLabel", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-icon-class' }),
    __metadata("design:type", String)
], PvdIcon.prototype, "pvdIconClass", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-name' }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], PvdIcon.prototype, "pvdName", null);
__decorate([
    n({ type: Object, attribute: 'pvd-native-svg-attributes' }),
    __metadata("design:type", Object)
], PvdIcon.prototype, "pvdNativeSvgAttributes", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-size' }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], PvdIcon.prototype, "pvdSize", null);

export { PvdIcon, SVG_PROTECTED_ATTR_MAP };
//# sourceMappingURL=pvd-icon.js.map
